import { useTranslation } from "react-i18next";
import { SearchboxV2 } from "#src/commonV2/Table/Searchbox";
import {
  FilterDropdownV2,
  IFilterDropdownProps,
} from "#src/commonV2/Table/Filter/FilterDropdown";

type Props = {
  selectedUserIds: string[];
  searchKeyword: string;
  setSearchKeyword: (keyword: string) => void;
  departmentFilterRenderProps: IFilterDropdownProps;
};

export const UsersFilter = (props: Props) => {
  const {
    selectedUserIds,
    searchKeyword,
    setSearchKeyword,
    departmentFilterRenderProps,
  } = props;
  const { t } = useTranslation("endpoint", { keyPrefix: "directory" });

  // --------------- DATA ---------------

  // --------------- METHODS ---------------

  // --------------- COMPUTED ---------------

  // --------------- METHODS ---------------

  // ---------------EFFECTS ---------------

  // --------------- RENDER ---------------

  return (
    <div className="flex justify-between items-center gap-2">
      {/* Filters */}
      <div className="flex gap-2">
        {selectedUserIds.length === 0 ? (
          <>
            <FilterDropdownV2 {...departmentFilterRenderProps} />
          </>
        ) : null}
      </div>
      {/* Filters end */}

      <div className="flex gap-2">
        {/* Searchbox */}
        <SearchboxV2
          value={searchKeyword}
          onChange={(value) => {
            setSearchKeyword(value);
          }}
          placeholder={t("table.search")}
        />
        {/* Searchbox end */}
      </div>
    </div>
  );
};
